class keepWidthDirective {
    constructor($timeout) {
        "ngInject";
        this.restrict = "A";
        this.$timeout = $timeout;
    }

    link(scope, element, attrs) {
        this.$timeout(() => {
            var width = element.prop("offsetWidth");
            var otherCss = element.css("cssText");
            attrs.$set("style", "width: " + (width + 32) + "px;" + otherCss);
        });
    }

    static create() {
		return new keepWidthDirective(...arguments);
	}
}

keepWidthDirective.create.$inject = ["$timeout"];

export {keepWidthDirective};





// WEBPACK FOOTER //
// ./sources/directives/keep-width.directive.js